import { Injectable } from "@angular/core";
import { DataService } from "./data.service";
import { Observer, Observable } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable()
export class ManualEditService {
  constructor(private dataService: DataService) {
  }
  url = environment.api_base_url;


  getManualEditData(date: Date, branchId: number): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      this.dataService.get(this.url + "dataentry/branch/manual-edit?date=" + date + "&branchId=" + branchId).subscribe((result) => {
        observer.next(result);
        observer.complete();
      },
        (error: Array<any>) => {
          observer.error(error);
          observer.complete();
        });
    });
  }

  getBranchDailyInputs(date: Date, branchId: number): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      this.dataService.get(this.url + "dataentry/branch/daily-input?date=" + date + "&branchId=" + branchId).subscribe((result) => {
        observer.next(result);
        observer.complete();
      },
        (error: Array<any>) => {
          observer.error(error);
          observer.complete();
        });
    });
  }

  getPublisherDailyInputs(date: Date, branchId: number): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      this.dataService.get(this.url + "dataentry/branch/publisher-arrival-times?date=" + date + "&branchId=" + branchId).subscribe((result) => {
        observer.next(result);
        observer.complete();
      },
        (error: Array<any>) => {
          observer.error(error);
          observer.complete();
        });
    });
  }

  getBranchComments(date: Date, branchId: number): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      this.dataService.get(this.url + "dataentry/branch/comments?date=" + date + "&branchId=" + branchId).subscribe((result) => {
        observer.next(result);
        observer.complete();
      },
        (error: Array<any>) => {
          observer.error(error);
          observer.complete();
        });
    });
  }



  saveBranchInputs(date: Date, branchId: number, data: any): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      this.dataService.post(this.url + "dataentry/branch/manual-edit/daily-input?date=" + date + "&branchId=" + branchId, data).subscribe((result) => {
        observer.next(result);
        observer.complete();
      },
        (error: Array<any>) => {
          observer.error(error);
          observer.complete();
        });
    });
  }

  savePublisherInputs(date: Date, branchId: number, data: any): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      this.dataService.post(this.url + "dataentry/branch/manual-edit/publisher-arrival-times?date=" + date + "&branchId=" + branchId, data).subscribe((result) => {
        observer.next(result);
        observer.complete();
      },
        (error: Array<any>) => {
          observer.error(error);
          observer.complete();
        });
    });
  }

  saveBranchComments(date: Date, branchId: number, data: any): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      this.dataService.post(this.url + "dataentry/branch/manual-edit/comments?date=" + date + "&branchId=" + branchId, data).subscribe((result) => {
        observer.next(result);
        observer.complete();
      },
        (error: Array<any>) => {
          observer.error(error);
          observer.complete();
        });
    });
  }


}